import IframeLoader from "_platform/output/iframeloader.vue";
import DsfStatsAuditFormulaForm from '../audit/formulaForm.vue';

let router = [
  {
    path: "/iframeloader/:state?",
    name: "iframeloader",
    component: IframeLoader,
    meta: {
      title: ""
    },
    props: route => {
      // let src = decodeURIComponent(route.fullPath)
      return {
        src: route.query.src
      };
    }
  },
  {
    path: "/pc/audit/formula/form",
    meta: {
      title: "审核公式维护",
      needLogin: false,
      waterMark: false
    },
    component: DsfStatsAuditFormulaForm
  }
];

export default router;